export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";